import React from "react";
import { Icon } from "../../../shared/Icon/Icon";

export const NoAddons = () => {
  return (
    <div className="NoAddons flex-a-center">
      <span>No active add-ons</span>
    </div>
  );
};
